const bannerPopupId = 'bannerPopup';
if (
	$(`#${bannerPopupId}`).length && !sessionStorage.getItem('banner_popup_has_shown')
) {
	openPopup(`#${bannerPopupId}`);
	sessionStorage.setItem('banner_popup_has_shown', 'true');
}

function openPopup(selector) {
	$("body").addClass("fix");
	$(selector).fadeIn();
}



// WEBPACK FOOTER //
// ./scripts/modules/banner-popup.js